import types from "../types";

// initial state
const state = {
  isLoading: false,
  loadingText: "Saving...",
};

// getters
const getters = {
  [types.getters.isLoading]: (state) => state.isLoading,
  [types.getters.loadingText]: (state) => state.loadingText,
};

// actions
const actions = {
  [types.actions.setIsLoading]({ commit }, { isLoading, loadingText }) {
    commit(types.mutations.setIsLoading, { isLoading, loadingText });
  },
};

// mutations
const mutations = {
  [types.mutations.setIsLoading](
    state,
    { isLoading = true, loadingText = "Saving..." },
  ) {
    state.isLoading = isLoading;
    state.loadingText = loadingText;
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};



// WEBPACK FOOTER //
// ./src/store/modules/loader.js